<template>
    <div>
        <Header @show-contact="showContact" :active="1" :title="'荟镜VR2'"></Header>
        <!-- 导航栏 -->
        <div class="detail-xr">
            <img class="banner_pc" src="../../assets/image/product/vr2_detail.jpg"></img>
            <img class="banner_m" src="../../assets/image/product/vr2_banner_m.jpg"></img>
        </div>
        <div class="advantage-xr">
            <img src="../../assets/image/product/vr2_detail_1.jpg">
            <img src="../../assets/image/product/vr2_detail_2.jpg">
        </div>
        <!-- <div class="advantage_m">
            <img src="../../assets/image/product/vr_m_1.jpg">
            <img src="../../assets/image/product/vr_m_2.jpg">
            <img src="../../assets/image/product/vr_m_3.jpg">
            <img src="../../assets/image/product/vr_m_4.jpg">
            <img src="../../assets/image/product/xr_m_1.jpg">
            <img src="../../assets/image/product/vr_m_6.jpg">
        </div> -->
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>

<script>
import Footer from '../../components/Footer.vue'
import Header from '../../components/Head.vue'
import Contact from '../../components/Contact.vue'
import Email from '../../components/Email.vue'
export default {
    data() {
        return {
            isContactVisible: false
        }
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    methods: {
        showContact() {
            this.isContactVisible = true
        },
        close() {
            this.isContactVisible = false;
        }
    },
}
</script>
<style scoped>
@import '../../assets/css/product/xr2.css';
</style>